import { FC, useContext, useEffect, useState } from "react";
import { ColumnConfig, wafflesKeyColumnName } from "@app/shared/waffles";
import { Waffles } from "@app/shared/waffles/Waffles";
import { UserModelFromApi } from "@app/admin/user-administration/userModel";
import { FlyoutContext, FlyoutFooter } from "@app/shared/Flyouts";
import { QESButton } from "@app/shared/qes-standards/Button";

interface AddRecipientPanelProps {
  licenseId: number;
  potentialUsers: UserModelFromApi[],
  onAddRecipients: (userIds: string[]) => void;
}

interface UserTableData {
  [wafflesKeyColumnName]: string;
  name: string;
  userId: number;
}

const userColumnConfig: ColumnConfig = {
  name: {
    displayText: "Name",
    testId: "name",
  },
};

const AddRecipientPanelContent: FC<AddRecipientPanelProps> = (props: AddRecipientPanelProps) => {
  const flyoutContext = useContext(FlyoutContext);
  const [selectedUserIds, setSelectedUserIds] = useState<string[]>([]);
  const [userTableData, setUserTableData] = useState<UserTableData[]>([]);

  useEffect(() => {
    if (!props.licenseId)
      return;

    setUserTableData(createUserWafflesTable(props.potentialUsers));
  }, []);

  const createUserWafflesTable = (data: UserModelFromApi[]) => {
    return data.map((rec) => {
      /* oxlint-disable sort-keys */
      return {
        key: rec.userId.toString(),
        userId: rec.userId,
        name: `${rec.firstName} ${rec.lastName}`
      };
      /* oxlint-enable sort-keys */
    });
  }

  const handleCheckboxChange = (selectedKeys: string[]) => {
    setSelectedUserIds(selectedKeys);
  }

  const handleAddClick = () => {
    props.onAddRecipients(selectedUserIds);
    flyoutContext.handleCloseFlyout();
  }

  return (
    <>
      <Waffles<UserTableData>
        columns={userColumnConfig}
        data={userTableData}
        showCheckboxes={true}
        selectedKeys={selectedUserIds}
        handleCheckboxChange={handleCheckboxChange}
        testId="add-recipient-panel-content__user-grid-waffles-table"
      />
      <div className="mt-3 mb-2">
        <FlyoutFooter
          submitButton={<QESButton
            qesTestId="add-recipient-panel-content__confirm"
            className="me-2"
            qesType="primary"
            onClick={handleAddClick}
            disabled={selectedUserIds.length === 0}
          >
            Add
          </QESButton>}
        />
      </div>
    </>
  );
}

export default AddRecipientPanelContent;
